// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__IkDFX","crop":"Slider_crop__I7UGv","content":"Slider_content__q4tj8","items":"Slider_items__Ix52h","item":"Slider_item__y70qs"};